import { v4 as uuid } from "uuid";
import ApiClient from "./ApiClient";
import ApiError from "./ApiError";

import { refreshSession, deleteSession } from "../actions/sessionActions";
import { store } from "../store";

import { redirectTo } from "../utils/browserUtils";
import { isFunction } from "../utils/langUtils";

/*
  SORRY FOR THE ISTANBUL IGNORIES, see:
  https://github.com/gotwarlost/istanbul/issues/690
*/

export class PrivateLcmApiClient extends ApiClient {
  getState: $TSFixMe;

  sessionCleaner: $TSFixMe;

  sessionRefresher: $TSFixMe;

  constructor(
    baseUrl: $TSFixMe,
    options: $TSFixMe,
    getState: $TSFixMe,
    sessionRefresh: $TSFixMe,
    sessionCleaner: $TSFixMe,
    useNewErrors: $TSFixMe,
  ) /* istanbul ignore next */ {
    super(baseUrl, options);
    this.sessionRefresher = sessionRefresh;
    this.getState = getState;
    this.sessionCleaner = sessionCleaner;
    this.useNewErrors = useNewErrors;
  }

  execute(request: $TSFixMe) {
    if (this.sessionRefresher && this.shouldRefreshSession()) {
      request.refreshSessionIfNeeded = false;
      return this.executeAfterSessionRefresh(request);
    }
    request.refreshSessionIfNeeded = true;
    /* istanbul ignore next */
    return super.execute(request);
  }

  // this executes the request after the session was refreshed.
  executeAfterSessionRefresh(request: $TSFixMe) {
    return this.refreshSession().then(() => {
      request.refreshSessionIfNeeded = false;
      const { token } = this.getState().session;
      if (token) {
        request.headers.Authorization = `Bearer ${token}`;
        /* istanbul ignore next */
        return super.execute(request);
      }
      if (this.getState().session.errors) {
        // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
        throw new ApiError(this.getState().session.errors);
      } else {
        // this correct the bug LIH-8760 given by Sentry if user tries to send a request to the Hub but session is timed out
        this.sessionCleaner().then(() => {
          redirectTo("/");
        });
        // this correct the bug LIH-8760 given by Sentry if user tries to send a request to the Hub but session is timed out
        return new Promise(() => true);
      }
    });
  }

  handleError(error: $TSFixMe, request: $TSFixMe) {
    if (
      error.response &&
      error.response.status === 401 &&
      this.sessionRefresher &&
      request.refreshSessionIfNeeded
    ) {
      return this.executeAfterSessionRefresh(request);
    }
    /* istanbul ignore next */
    return super.handleError(error, request);
  }

  cleanSession() {
    return Promise.resolve(this.sessionCleaner());
  }

  refreshSession() {
    return Promise.resolve(this.sessionRefresher());
  }

  shouldRefreshSession() {
    return (
      this.getState().session.tokenExpiresAt === null ||
      this.getState().session.tokenExpiresAt - Date.now() <= 0
    );
  }
}

export function lcmApiClientWithVersion(
  dispatchOrCache = store().dispatch,
  getStateOrUseNewErrors = store().getState,
  cache = true,
  version = "v1",
) {
  const dispatch = isFunction(dispatchOrCache)
    ? dispatchOrCache
    : store().dispatch;
  /* istanbul ignore next */
  const getState = isFunction(getStateOrUseNewErrors)
    ? getStateOrUseNewErrors
    : store().getState;
  const useCache =
    (isFunction(dispatchOrCache) && cache) ||
    (!isFunction(dispatchOrCache) && dispatchOrCache);

  // Since this is a core functionality to all applications. Fix-me is removed to avoid sonarqube issues
  // @ts-expect-error TS(7017) Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  const { lcmApiUrl, lcmApiBaseUrl } = globalThis.configuration;
  // Older servers only send the /v1-suffixed lcmApiUrl.
  const baseUrl = `${lcmApiBaseUrl ?? lcmApiUrl.replace(/\/v\d+$/, "")}/${version}`;
  const { token } = getState().session;
  const headers: Record<string, string | number> = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  if (!useCache) {
    headers["If-None-Match"] = uuid();
    headers["If-Modified-Since"] = 0;
  }

  return new PrivateLcmApiClient(
    baseUrl,
    { headers },
    getState,
    () => dispatch(refreshSession()),
    () => dispatch(deleteSession()),
    getStateOrUseNewErrors && !isFunction(getStateOrUseNewErrors),
  );
}

export default function lcmApiClient(
  dispatchOrCache = store().dispatch,
  getStateOrUseNewErrors = store().getState,
  cache = true,
) {
  const dispatch = isFunction(dispatchOrCache)
    ? dispatchOrCache
    : store().dispatch;
  /* istanbul ignore next */
  const getState = isFunction(getStateOrUseNewErrors)
    ? getStateOrUseNewErrors
    : store().getState;
  const useCache =
    (isFunction(dispatchOrCache) && cache) ||
    (!isFunction(dispatchOrCache) && dispatchOrCache);

  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  const baseUrl = global.configuration.lcmApiUrl;
  const { token } = getState().session;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  if (!useCache) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    headers["If-None-Match"] = uuid();
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    headers["If-Modified-Since"] = 0;
  }

  return new PrivateLcmApiClient(
    baseUrl,
    { headers },
    getState,
    () => dispatch(refreshSession()),
    () => dispatch(deleteSession()),
    getStateOrUseNewErrors && !isFunction(getStateOrUseNewErrors),
  );
}
